// Define supported log types
type LogType = 'log' | 'debug' | 'error';

/**
 * Kinetic logger used across the builder. Logging only happens when the URL contains `?log=1`.
 *
 * Flexible calling convention:
 * - kineticLog('message', obj, ...)
 * - kineticLog('debug', 'message', obj, ...)
 * - kineticLog('error', error)
 */
export function kineticLog(...args: any[]): void {
  // Guard: check if log parameter is present in URL
  const urlParams = new URLSearchParams(window.location.search);
  const logEnabled = urlParams.get('log') === '1';
  if (!logEnabled) {
    return;
  }

  // Determine type and payload
  let type: LogType = 'log';
  let payload: any[] = args;

  if (args.length > 0 && typeof args[0] === 'string') {
    const possibleType = args[0].toLowerCase();
    if (possibleType === 'log' || possibleType === 'debug' || possibleType === 'error') {
      type = possibleType as LogType;
      payload = args.slice(1);
    }
  }

  // Prepare the log prefix
  const prefix = `[Kinetic ${type.toUpperCase()}]`;

  // Call appropriate console method based on type
  switch (type) {
    case 'error':
      console.error(prefix, ...payload);
      break;
    case 'debug':
      console.debug(prefix, ...payload);
      break;
    case 'log':
    default:
      console.log(prefix, ...payload);
      break;
  }
}

/** Convenience wrappers for explicit levels */
export const kineticDebug = (...args: any[]) => kineticLog('debug', ...args);
export const kineticError = (...args: any[]) => kineticLog('error', ...args);